import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=9399f6c8&scoped=true&"
import script from "./SerialNumber.vue?vue&type=script&lang=js&"
export * from "./SerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./SerialNumber.vue?vue&type=style&index=0&id=9399f6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9399f6c8",
  null
  
)

export default component.exports